// script.js (ring index.html) ~sdg
'use strict'
console.time('LoadTime')

import './normalize.css'
import './style.css'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import * as dat from 'lil-gui'
import { MeshBasicMaterial } from 'three'

/**
 * Base
 */
// Debug
const gui = new dat.GUI({ width: 200 })
gui.close()
gui.hide()

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

/**
 * Axes Helper
 */
//const axesHelper = new THREE.AxesHelper(2)
//scene.add(axesHelper)

/*
 * Objects
 */
// Geometry
const ringGeometry = new THREE.RingGeometry( 0.25, 1, 32 )
// Material
const ringMaterial = new MeshBasicMaterial({ color: 0x00ff00, wireframe: true })
// Ring
const ring = new THREE.Mesh(ringGeometry, ringMaterial)
ring.rotation.x = Math.PI * 0.25
scene.add(ring)

/**
 * Sizes
 */
const sizes = {
  width: window.innerWidth,
  height: window.innerHeight
}
// Resize
window.addEventListener('resize', () =>
{
  // Update sizes
  sizes.width = window.innerWidth
  sizes.height = window.innerHeight

  // Update camera
  camera.aspect = sizes.width / sizes.height
  camera.updateProjectionMatrix()

  // Update renderer
  renderer.setSize(sizes.width, sizes.height)
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.z = 4
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
  canvas: canvas,
  alpha: true
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

/**
 * Animate
 */
const clock = new THREE.Clock()

const animate = () =>
{
  const elapsedTime = clock.getElapsedTime()

  // Update controls
  controls.update()

  // Update objects
  ring.rotation.y = elapsedTime

  // Render
  renderer.render(scene, camera)

  // Call animate again on next frame
  window.requestAnimationFrame(animate)
}

animate()
console.timeEnd('LoadTime')
// EOF script.js (ring index.html) ~sdg